<template>
  <div class="row">
    <div class="col-xl-8 mb-0">
      <title-bread-crumb :page="page" />
    </div>
    <div class="col-xl-4 d-flex justify-content-end align-items-center actions">
      <slot name="custom_actions" />
      <action-button
        v-if="hasReturn"
        @click="onReturn"
        i="fas fa-arrow-circle-left"
        variant="custom-btn-return m-2"
      >
        Regresar
      </action-button>
      <action-button
        v-if="hasSave"
        variant="success"
        :i="`fas fa-save pr-1`"
        @click="save"
      >
        Guardar
      </action-button>
      <action-button
        v-if="hasAdd"
        variant="success"
        :i="`fas fa-file-plus pr-1`"
        @click="add"
      >
        {{ addText }}
      </action-button>
      <action-button
        :disabled="submitDisabled"
        v-if="hasSubmit"
        variant="success"
        :i="`fas fa-save pr-1`"
        @click="submit"
      >
        Someter
      </action-button>
      <!-- De aqui en adelante esto no deberia estar aqui --->
      <action-button
        :disabled="printDisabled"
        v-if="hasPrint"
        variant="custom-btn-return m-2"
        :i="`fas fa-print pr-1`"
        @click="print"
      >
        Imprimir
      </action-button>
      <action-button
        :disabled="infoDisabled"
        v-if="hasInfo"
        variant="custom-btn-return m-2 btn btn-dropdown-actions px-4"
        :iright="'fas fa-angle-down'"
        @click="info"
      >
        Informes
      </action-button>
      <action-button
        :disabled="assignProposalDisabled"
        v-if="hasAssingProposal"
        variant="custom-btn-return m-2"
        :i="`fas fa-clone pr-1`"
        @click="assignProposal"
      >
        Asignar Propuestas
      </action-button>
      <action-button
        :disabled="evaluatorsDisabld"
        v-if="hasEvaluators"
        variant="success m-2 pr-3"
        :i="`fas fa-users pr-1`"
        @click="evaluators"
      >
        Evaluadores
      </action-button>
      <action-button
        v-if="hasContinue"
        variant="success"
        i="fas fa-arrow-circle-right pr-1"
        @click="onContinue"
      >
        Continuar
      </action-button>
    </div>
    <div class="col-12 p-0">
      <div class="dropdown-divider mt-0 pb-2 w-100 mb-4"></div>
    </div>
  </div>
</template>

<script>
import TitleBreadCrumb from '@/components/common/page/TitleBreadcrumb'
import { ActionButton } from '@/components/common'

export default {
  components: {
    TitleBreadCrumb,
    ActionButton,
  },

  props: {
    page: {
      type: Object,
      default: () => {},
    },
    hasReturn: {
      type: Boolean,
      default: () => false,
    },
    hasSave: {
      type: Boolean,
      default: () => false,
    },
    hasSubmit: {
      type: Boolean,
      default: () => false,
    },
    hasPrint: {
      type: Boolean,
      default: () => false,
    },
    hasAdd: {
      type: Boolean,
      default: () => false,
    },
    hasInfo: {
      type: Boolean,
      default: () => false,
    },
    hasAssingProposal: {
      type: Boolean,
      default: () => false,
    },
    hasEvaluators: {
      type: Boolean,
      default: () => false,
    },
    hasContinue: {
      type: Boolean,
      default: () => false,
    },
    submitDisabled: {
      type: Boolean,
      default: () => false,
    },
    printDisabled: {
      type: Boolean,
      default: () => false,
    },
    stickyButtons: {
      type: Boolean,
      default: () => false,
    },
    addText: {
      type: String,
      default: () => 'Añadir',
    },
    assignProposal: {
      type: Function,
      default: () => false,
    },
  },
  methods: {
    add() {
      this.$emit('onAdd')
    },
    save() {
      this.$emit('onSave')
    },
    onReturn() {
      this.$emit('onReturn')
    },
    submit() {
      this.$emit('onSubmit')
    },
    print() {
      this.$emit('onPrint')
    },
    onContinue() {
      this.$emit('onContinue')
    },
  },
}
</script>

<style scoped>
.custom-btn-return {
  border: 1px solid #2db782;
  color: #2db782;
}

.custom-btn-return:hover {
  background-color: #2db782;
  border: 1px solid #2db782;
  color: #fff;
}

@media screen and (max-width: 870px) {
  .actions {
    display: block !important;
  }

  .actions button {
    margin-bottom: 10px;
  }
}
</style>
